import { MIN_INPUT_LEN_FOR_API_CALL } from "./constants";
import { ASResponse, SearchResponse } from "types/searchApi/response";

export const memoizeFunc = <F extends () => unknown>(
  func: F,
): (() => ReturnType<F>) => {
  let cache: ReturnType<F>;
  return () => {
    if (cache) return cache;
    cache = func() as ReturnType<F>;
    return cache;
  };
};

export const isValidASTerm = (term?: string): term is string =>
  Boolean(term && term.length >= MIN_INPUT_LEN_FOR_API_CALL);

export const formatResponse = (
  res: SearchResponse | ASResponse | null,
  recentSearches?: string[],
  searchedTerm?: string,
) =>
  !res?.response
    ? {
        searchedTerm,
        searches: { recent: recentSearches },
      }
    : {
        searchedTerm,
        products: res.response.product_list,
        brands: res.response.autosuggest?.brands,
        searches: {
          recent: recentSearches,
          suggested: res.response.autosuggest?.suggestions,
        },
      };

export const sanitizeInput = (searchTerm: string | undefined) => {
  const pattern = /[^\w]|_/g;
  return searchTerm
    ? searchTerm.replace(pattern, " ").replace(/\s+/g, " ").trim()
    : "";
};
